import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar, FiArrowDownRight } from "react-icons/fi";

export default function FrequentLateArrivals() {
  const [filter, setFilter] = useState("Today");

  return (
    <Card className="fla-card shadow-sm h-100">
      <Card.Body className="fla-body">

        {/* BG SHAPE */}
        <div className="fla-bg-shape"></div>

        {/* HEADER */}
        <div className="fla-header">
          <h5>Frequent Late Arrivals</h5>

          <Dropdown align="end">
            <Dropdown.Toggle className="fla-dropdown">
              <FiCalendar size={14} /> {filter}
            </Dropdown.Toggle>

            <Dropdown.Menu className="index-value" >
              {["Today", "Weekly", "Monthly"].map((item) => (
                <Dropdown.Item key={item} onClick={() => setFilter(item)}>
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* TEXT */}
        <p className="fla-sub">No of Employees</p>

        <h3 className="fla-count">
          22 <span className="fla-badge">Warnings</span>
        </h3>

        {/* FOOTER */}
        <div className="fla-footer">

          {/* AVATARS */}
          <div className="fla-avatars">
            {[
              "avatar-02-1.jpg",
              "avatar-03.jpg",
              "avatar-05.jpg",
              "avatar-06-1.jpg",
              "avatar-07-1.jpg",
            ].map((img, i) => (
              <img
                key={i}
                src={`/assets/img/profiles/${img}`}
                className="fla-avatar"
                alt=""
              />
            ))}

            <div className="fla-avatar more">+9</div>
          </div>

          {/* PERCENT */}
          <div className="fla-percent">
            +15.5%
            <span className="fla-arrow">
              <FiArrowDownRight size={14} />
            </span>
          </div>
        </div>

      </Card.Body>

      {/* ✅ EXACT CSS */}
      <style>{`

/* CARD */
.fla-card {
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  background: #fff;
}

/* BODY */
.fla-body {
  position: relative;
  padding: 20px;
  z-index: 1;
}

/* 🔥 CURVED BACKGROUND */
.fla-bg-shape {
  position: absolute;
  right: 0;
  top: 0;
  width: 60%;
  height: 100%;
  background: #f3f4f6;
  border-top-left-radius: 120px;
  border-bottom-left-radius: 120px;
  z-index: 0;
}

/* HEADER */
.fla-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  position: relative;
  z-index: 2;
}

.fla-header h5 {
  font-size: 18px;
  font-weight: 600;
}

/* DROPDOWN */
.fla-dropdown,
.fla-dropdown:hover,
.fla-dropdown:focus,
.fla-dropdown:active {
  background: #fff !important;
  border: 1px solid #e5e7eb !important;
  color: #111 !important;
  box-shadow: none !important;
  font-size: 13px;
  padding: 6px 12px;
}

/* TEXT */
.fla-sub {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 5px;
  position: relative;
  z-index: 2;
}

/* COUNT */
.fla-count {
  font-size: 28px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  z-index: 2;
}

.index-value{
z-index:100;
}
/* BADGE */
.fla-badge {
  background: #f3e8ff;
  color: #9333ea;
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 6px;
}

/* FOOTER */
.fla-footer {
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}

/* AVATARS */
.fla-avatars {
  display: flex;
  align-items: center;
}

.fla-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-left: -10px;
  object-fit: cover;
}

.fla-avatar:first-child {
  margin-left: 0;
}

.fla-avatar.more {
  background: #fff;
  border: 1px solid #ddd;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* PERCENT BOX */
.fla-percent {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 4px 6px 4px 12px;   /* ✅ balanced padding */
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;           /* ✅ prevents overflow issues */
}

/* RED ICON FIX */
.fla-arrow {
  width: 30px;
  height: 30px;
  min-width: 30px;           /* ✅ prevents shrink */
  border-radius: 50%;
  background: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
  .dropdown-menu {
  z-index: 9999 !important;
}

/* MOBILE */
@media (max-width: 768px) {
  .fla-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .fla-bg-shape {
    width: 100%;
    height: 40%;
    border-radius: 0 0 100px 100px;
  }

  .fla-count {
    font-size: 22px;
  }

  .fla-avatar {
    width: 26px;
    height: 26px;
  }
}

      `}</style>
    </Card>
  );
}